<template>
  <div>
    <!-- 企业信息 -->
    <div
      class="layout-header-tab"
      style="width: calc(100% - 13.25rem); z-index: 1"
    >
      <span
        @click="tabs.callback(item.key)"
        class="tab"
        v-for="item in tabs.items"
        :class="{ active: active == item.key }"
        :key="item.key"
        >{{ item.title }}</span
      >
    </div>
    <router-view ref="content" class="layout content" />
  </div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
export default {
  name: 'companySettings',
  data() {
    return {
      tabs: {
        items: [
          {
            key: '1',
            title: '企业测评'
          },
          {
            key: '2',
            title: '测评设置'
          },
        ],
        callback: (key) => {
          let path = ''
          switch (key) {
            case '1':
              path = '/ratingEvaluation/rate/'
              break
            case '2':
              path = '/ratingEvaluation/setting/'
              break
          }
          if (this.selfAreaId) {
            path += this.selfAreaId
          }
          // if (key !== '1') {
          //   // 如果不在企业管理 判断区域权限
          //   if (this.userLevel == 2) {
          //     this.$router.push(path)
          //   } else {
          //     this.$message.warning('请选择复合区及下级区域！')
          //   }
          // } else {
          //   this.$router.push(path)
          // }
          this.$router.push(path)
        }
      }
    }
  },
  computed: {
    ...mapGetters(['user', 'selfAreaId', 'userLevel']),
    active() {
      switch (this.$route.name) {
        case 'rate':
          return "1"
        case 'setting':
          return "2"
        default:
          return "1";
      }
    }
  }
}
</script>

<style lang="less" scoped>
.system-setting {
  background: rgba(240, 242, 245, 1);
  width: 100%;
  height: 100%;
}

.layout-header-tab {
  position: fixed;
  top: 56px;
  width: 100%;
  background-color: #fff;
  height: 40px;
  line-height: 40px;
  padding: 0 16px;
  border-bottom-color: white;
  left: 8px;
  .tab {
    font-size: 12px;
    color: #999;
    padding: 0 16px;
    cursor: pointer;

    &:hover,
    &.active {
      font-weight: bold;
      color: #333;
    }
  }
}

.content {
  margin-top: 96px;
  background: #f0f2f5;
}
</style>
